function epicAccount () {
  Shopify.theme.jsEpicAccount = {
    init: function init() {
      this.headerRewardsIcon();
      this.accountSidebar();
      this.accountAccordion();
      this.toggleLoginAndResetPassword();
      this.getLoyaltyBalanceForCustomer();
      this.accountMobileNavigation();
      this.accountGetOrders();
      this.reorderItem();
      this.reorderAllItems();
      this.accountOftenBoughtTogether();
      this.logout();
    },
    accountAccordion: function accountAccordion() {
      const mobileAccordions = document.querySelectorAll('.accordion-mobile');

      if (mobileAccordions.length > 0 && window.innerWidth <= 768) {
        mobileAccordions.forEach(accordion => {
          accordion.addEventListener('click', function () {
            const type = accordion.getAttribute('data-column-type');

            const toggleActiveAccordions = selector => {
              const accordionsToClose = document.querySelectorAll(selector);
              accordionsToClose.forEach(close => close.click());
            };

            if (type === 'login') {
              toggleActiveAccordions('.register-column .accordion-mobile.active');
            } else if (type === 'register') {
              toggleActiveAccordions('.login-column .accordion-mobile.active');
            }

            this.classList.toggle('active');
            const panel = this.nextElementSibling;
            if (!panel) return;
            panel.style.maxHeight = panel.style.maxHeight ? null : `${panel.scrollHeight}px`;
          });
        });
      }
    },
    accountGetOrders: async function accountGetOrders() {
      const ordersList = document.querySelector('.customer-orders');
      if (!ordersList) return;
      const customerId = ordersList.getAttribute('data-customer-id');
      if (!customerId) return;
      const orders = document.querySelectorAll('.customer-orders-order');
      window.location.search.replace('?page=', '');
      let transactionHistory = await Sf9Loyalty.getTransactionHistory(customerId).then(data => {
        return data;
      });
      orders.forEach(order => {
        const orderNumber = order.getAttribute('data-order-number').replace('#', '');
        const orderTransaction = transactionHistory.find(transaction => transaction.orderNumber === orderNumber);

        if (orderTransaction) {
          const totalPoints = order.querySelector('.order-details-total-points .order-details-info');

          if (totalPoints) {
            totalPoints.textContent = orderTransaction.loyaltyEarned;
          }
        }
      });
    },
    toggleLoginAndResetPassword: function toggleLoginAndResetPassword() {
      const goToResetPassword = document.querySelector('.js-got-to-recover');
      const goToLogin = document.querySelector('.js-go-to-login');
      const resetPasswordHeader = document.querySelector('.reset-password-header');
      const resetPasswordPanel = document.querySelector('.reset-password-pannel');
      const loginHeader = document.querySelector('.login-header');
      const loginPanel = document.querySelector('.login-panel');

      if (loginHeader) {
        loginHeader.click();
      }

      const togglePanel = (header, panel, state) => {
        if (panel) panel.classList.toggle('show', state);
        if (header) header.classList.toggle('show', state);
        if (header && state) header.click();
      };

      if (goToResetPassword) {
        goToResetPassword.addEventListener('click', () => {
          togglePanel(resetPasswordHeader, resetPasswordPanel, true);
          togglePanel(loginHeader, loginPanel, false);
        });
      }

      if (goToLogin) {
        goToLogin.addEventListener('click', () => {
          togglePanel(resetPasswordHeader, resetPasswordPanel, false);
          togglePanel(loginHeader, loginPanel, true);
        });
      }
    },
    getLoyaltyBalanceForCustomer: async function getLoyaltyBalanceForCustomer() {
      const customerBalanceCurrencyElements = document.querySelectorAll('.js-loyalty-balance-currency');
      if (customerBalanceCurrencyElements.length <= 0) return false;
      let customerBalanceCurrency = await Sf9Loyalty.requestCardInformation().then(data => {
        if (data) {
          return data.LoyaltyBalanceCurrency;
        } else {
          return 0;
        }
      });
      customerBalanceCurrencyElements.forEach(balanceCurrency => {
        balanceCurrency.textContent = customerBalanceCurrency;
      });
    },
    accountMobileNavigation: function accountMobileNavigation() {
      let sidebarNavButtons = document.querySelectorAll('.js-sidebar-nav-btn');

      if (sidebarNavButtons.length > 0) {
        sidebarNavButtons.forEach(btn => {
          btn.addEventListener('click', e => {
            let navBlock = btn.closest('.sidebar-navigation-block');
            if (!navBlock) return false;

            if (navBlock.classList.contains('sidebar-nav-link')) {
              let link = navBlock.querySelector('a');
              btn.classList.add('active');
              if (!link) return false;
              window.location.href = link.href;
              return true;
            }

            let isOpen = navBlock.classList.contains('active');
            let activeNavBlocks = document.querySelectorAll('.sidebar-navigation-block.active');

            if (activeNavBlocks.length > 0) {
              activeNavBlocks.forEach(activeBlock => {
                activeBlock.classList.remove('active');
              });
            }

            if (!isOpen) {
              navBlock.classList.add('active');
            }
          });
        });
      }

      let closeNavBtns = document.querySelectorAll('.nav-close');

      if (closeNavBtns.length > 0) {
        closeNavBtns.forEach(btn => {
          btn.addEventListener('click', e => {
            let navBlock = btn.closest('.sidebar-navigation-block');
            if (!navBlock) return false;
            navBlock.classList.remove('active');
          });
        });
      }
    },
    reorderItem: function reorderItem() {
      let orderItems = document.querySelectorAll('.js-order-products-item');
      let self = this;

      if (orderItems.length > 0) {
        let reorderItemBtns = document.querySelectorAll('.product-reorder');
        let miniCart = document.querySelector('mini-cart');
        reorderItemBtns.forEach(reorderItemBtn => {
          reorderItemBtn.addEventListener('click', e => {
            let items = [];
            reorderItemBtn.setAttribute('disabled', true);
            reorderItemBtn.classList.add('loading');
            reorderItemBtn.classList.add('adding');
            const sections = miniCart ? miniCart.getSectionsToRender().map(section => section.id) : [];
            let orderItem = reorderItemBtn.closest('.js-order-products-item');
            if (!orderItem) return false;
            let idElem = orderItem.querySelector('form input[name="id"]');
            let quantityElem = orderItem.querySelector('form input[name="quantity"]');
            let error = orderItem.querySelector('.product-form__error-message-wrapper');

            if (error) {
              error.classList.add('hidden');
            }

            if (idElem && quantityElem) {
              let id = idElem.value;
              let quantity = quantityElem.value;
              let maxQuantity = quantityElem.getAttribute('max');

              if (parseInt(maxQuantity) == 0) {
                if (error) {
                  error.classList.remove('hidden');
                }

                reorderItemBtn.classList.remove('loading');
                reorderItemBtn.classList.add('added');
                reorderItemBtn.classList.remove('adding');
                reorderItemBtn.removeAttribute('disabled');
                return false;
              } else if (parseInt(maxQuantity) < parseInt(quantity)) {
                quantity = maxQuantity;

                if (error) {
                  error.classList.remove('hidden');
                }
              }

              items.push({
                id: id,
                quantity: quantity
              });
            }

            let formData = {
              items: items,
              sections: sections,
              sections_url: window.location.pathname
            };
            self.addToCart(formData, reorderItemBtn, error);
          });
        });
      }
    },
    reorderAllItems: function reorderAllItems() {
      let orderItems = document.querySelectorAll('.js-order-products-item');
      let reorderAllItemsBtn = document.querySelector('.order-reorder-button');
      let miniCart = document.querySelector('mini-cart');
      let self = this;

      if (orderItems.length > 0 && reorderAllItemsBtn) {
        reorderAllItemsBtn.addEventListener('click', e => {
          let items = [];
          reorderAllItemsBtn.setAttribute('disabled', true);
          reorderAllItemsBtn.classList.add('loading');
          reorderAllItemsBtn.classList.add('adding');
          const sections = miniCart ? miniCart.getSectionsToRender().map(section => section.id) : [];
          orderItems.forEach(item => {
            let idElem = item.querySelector('form input[name="id"]');
            let quantityElem = item.querySelector('form input[name="quantity"]');
            let error = item.querySelector('.product-form__error-message-wrapper');

            if (error) {
              error.classList.add('hidden');
            }

            if (idElem && quantityElem) {
              let id = idElem.value;
              let quantity = quantityElem.value;
              let maxQuantity = quantityElem.getAttribute('max');

              if (parseInt(maxQuantity) == 0) {
                if (error) {
                  error.classList.remove('hidden');
                }

                return false;
              } else if (parseInt(maxQuantity) < parseInt(quantity)) {
                quantity = maxQuantity;

                if (error) {
                  error.classList.remove('hidden');
                }
              }

              items.push({
                id: id,
                quantity: quantity
              });
            }
          });
          let formData = {
            items: items,
            sections: sections,
            sections_url: window.location.pathname
          };
          self.addToCart(formData, reorderAllItemsBtn);
        });
      }
    },
    addToCart: function addToCart(formData, button, error) {
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(response => {
        return response.json();
      }).then(parsedState => {
        if (parsedState.status === 422) {
          if (error) {
            error.classList.remove('hidden');
          }
        } else {
          parsedState.items.forEach(item => {
            let quantityElem = document.querySelector(`[data-quantity-variant-id="${item.variant_id}"]`);

            if (quantityElem) {
              let maxQuantity = quantityElem.getAttribute('variant-max-quantity');
              let newMaxQuantity = parseInt(maxQuantity) - item.quantity;
              quantityElem.setAttribute('max', newMaxQuantity);
            }
          });
          let addedToCartBannerSubscriptions = document.querySelector('.added-to-cart-banner');
          Shopify.theme.jsAjaxCart.onCartChange();
          Shopify.theme.jsCartCounter.update();

          if (addedToCartBannerSubscriptions) {
            addedToCartBannerSubscriptions.classList.add('visible');
            setTimeout(() => {
              addedToCartBannerSubscriptions.classList.remove('visible');
              document.body.classList.remove('subscription-active');
            }, 1000);
          }
        }
      }).catch(error => {
        console.error('Error:', error);
      }).finally(() => {
        button.classList.remove('loading');
        button.classList.add('added');
        button.classList.remove('adding');
        button.removeAttribute('disabled');
      });
    },
    accountSidebar: function accountSidebar() {
      let accountContainer = document.querySelector('.account-container');
      if (!accountContainer) return false;
      let sidebar = accountContainer.querySelector('.account-sidebar');

      if (sidebar) {
        accountContainer.style.minHeight = sidebar.offsetHeight + 150 + 'px';
        window.addEventListener('resize', () => {
          accountContainer.style.minHeight = sidebar.offsetHeight + 150 + 'px';
        });
      } else {
        accountContainer.style.minHeight = 'unset';
      }
    },
    headerRewardsIcon: function headerRewardsIcon() {
      const remindCustomerRewards = document.querySelector('.remind-customer-rewards');
      if (!remindCustomerRewards) return;
      const isHidden = localStorage.getItem('hideRemindCustomerRewards');

      if (isHidden === 'true') {
        remindCustomerRewards.style.display = 'none';
        return;
      }

      remindCustomerRewards.addEventListener('click', () => {
        remindCustomerRewards.addEventListener('mouseout', event => {
          remindCustomerRewards.style.display = 'none';
          localStorage.setItem('hideRemindCustomerRewards', 'true');
        });
      });
    },
    accountOftenBoughtTogether: function accountOftenBoughtTogether() {
      let OftenBoughtTogetherContainer = document.querySelector('[data-often-bought-together-container]');
      if (!OftenBoughtTogetherContainer) return false;
      let section_id = OftenBoughtTogetherContainer.getAttribute('data-section-id');
      let limit = OftenBoughtTogetherContainer.getAttribute('data-product-limit');
      let skus = OftenBoughtTogetherContainer.getAttribute('data-skus');
      if (!section_id || !limit || !skus) return false;
      skus = skus.split(',');
      let url;

      if (Orchestra && Orchestra.epic_often_bought_together_endpoint) {
        url = Orchestra.epic_often_bought_together_endpoint;
      } else {
        return false;
      }

      let body = {
        limit: parseInt(limit),
        min_qty: 1,
        date_from: '2000-01-01',
        price_from: 1.0,
        price_to: 1000000.0,
        skus: skus
      };
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      }).then(function (response) {
        return response.json();
      }).then(function (json) {
        if (!json.success == true) return false;

        if (json.response.length > 0) {
          let fetchPromises = json.response.map((item, index) => {
            let productHandle = item.handle;
            return fetch(`/products/${productHandle}?section_id=epic-product-card`).then(response => {
              if (!response.ok) {
                throw new Error(`Failed to fetch section: ${response.statusText}`);
              }

              return response.text();
            }).then(html => {
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = html;
              const productCardSection = tempDiv.querySelector('#shopify-section-epic-product-card');
              if (!productCardSection) return false;
              let slide = document.createElement('div');
              slide.id = `Slide-new-products-${section_id}-${index}`;
              slide.classList.add('grid__item', 'slider__slide', 'account-product-card');
              slide.innerHTML = productCardSection.innerHTML;
              OftenBoughtTogetherContainer.append(slide);
            }).catch(error => {
              console.error('Error fetching section:', error);
            });
          });
          Promise.all(fetchPromises).then(() => {
            let sliderElement = OftenBoughtTogetherContainer.closest('.epic-account-product-slider');
            if (sliderElement) Shopify.theme.jsEpicAccountProductSlider.init(sliderElement);
            wishlistModel.addListeners();
          }).catch(error => {
            console.error('Error during fetch operations:', error);
          });
        } else {
          let section = OftenBoughtTogetherContainer.closest('.epic-account-often-bought-together');
          if (section) section.classList.add('hidden');
        }
      }).catch(error => console.error(error));
    },
    logout: function logout() {
      let logoutBtns = document.querySelectorAll('a[href*="/account/logout"]');
      logoutBtns.forEach(logoutBtn => {
        logoutBtn.addEventListener('click', e => {
          e.preventDefault();
          window.location.href = '/account/logout';
        });
      });
    }
  };
  Shopify.theme.jsEpicAccount.init();
}

export { epicAccount as default };
